import React, { Component } from 'react';
import { PropTypes, array, bool } from 'prop-types';
import { Field, FormSection, reduxForm } from 'redux-form'
import Address from '../../shared/components/form-section/Address';
import Contact from '../../shared/components/form-section/Contact';

import { Form, Input, Button, Card, CardColumns, CardTitle, CardBody, CardHeader, Col, Row } from 'reactstrap';
import Snackbar from '@material-ui/core/Snackbar';
import debounce from 'lodash/debounce'
// import DropdownList from 'react-widgets/lib/DropdownList'
import Combobox from 'react-widgets/lib/Combobox';
import { getBanks, getBanksList } from '../../actions/bankActions';

import SimpleLineIcon from 'react-simple-line-icons';
import {
  renderField,
  renderTextareaField,
  renderSelectField,
  renderCheckbox,
  renderDateField,
  renderDateFieldGerman,
  renderRadioGroup,
  renderMultiselect,
  renderNumberField, renderCombobox
} from '../../shared/components/form-field/ReduxFormFields';

import { Radio, RadioGroup } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';

import { reset } from 'redux-form';
import { SubmissionError } from 'redux-form'
import { stopSubmit } from 'redux-form'

import { getTransaction, addTransaction, updateTransaction, resetTransaction } from '../../actions/transactionActions';
import { getBrands } from '../../actions/brandActions';
import { getOfferByBrand } from '../../actions/offerByBrand';
import { checkAuth } from '../../actions/sessionActions';
import { validate } from './validate';

import './TransactionForm.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// Redux Store
import configureStore from '../../shared/redux/configureStore';
import { off } from 'hammerjs';
// Configuring Redux Store
const store = configureStore(window.initialState);

class TransactionForm extends Component {

  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleOfferChange = this.handleOfferChange.bind(this);
    this.handleStatusChange = this.handleStatusChange.bind(this);
    this.handleBankChange = this.handleBankChange.bind(this)
    this.handleBankFilterChange = debounce(this.handleBankFilterChange.bind(this), 300);

    this.currency = React.createRef();
    this.commission = React.createRef();

    this.state = {
      id: this.props.match.params.id,
      open: false,
      create: false,
      offers: [],
      brands: null,
      selectedBrand: '',
      banks: [],
      selectedBank: null,
      status: null,
      brandSearchResult: null,
      currency: '12412'
    }
  }

  componentDidMount(props) {
    console.log('componentDidMount');

    const urlParams = new URLSearchParams(window.location.search);
    const idFromUrl = urlParams.get('id');
    if (idFromUrl) {
      this.setState({ selectedBank: parseInt(idFromUrl) });
    }

    const { getTransaction, addTransaction, updateTransaction, getBrands } = this.props;
    if (this.state.id) {
      getTransaction({ id: this.state.id, bank_id: this.props.match.params.bank_id });
    } else {

      getBanksList().then(({ items }) => this.setState(item => ({ ...item, banks: items })));

    }
    getBrands()
  }

  componentDidUpdate(prevProps, prevState) {
    console.log('componentDidUpdate')
    console.log(this.props);

    if (!this.props.match.params.id) {
      if (!this.state.create) {
        //this.props.dispatch(reset('transactionForm'));  // requires form name
        this.props.initialize();
        store.dispatch(resetTransaction());
        this.setState({ create: true });
        this.setState({ brands: null });
        this.setState({ id: null });
      }
    } else {
      if (this.state.open) {
        window.location.href = `/transactions/transactions?bank_id=${this.props.match.params.bank_id}`;
      }
    }
  }

  handleBankFilterChange = debounce((value) => {
    if (typeof value === 'object') {
      this.handleBankChange(value);
    } else {
      getBanksList({ 'search[name]': value }).then(({ items }) => {
        if (JSON.stringify(this.state.banks) !== JSON.stringify(items)) {
          this.setState({ banks: items });
        }
      });
    }

  }, 300);

  handleGetOfferbyBrand(brandId) {
    getOfferByBrand({ 'search[brand]': brandId, 'search[type]': 'Cashback', 'search[active]': true }).then((result) => {
      if (result?.items?.length) {
        this.setState(item => ({ ...item, offers: result.items }));
      } else {
        this.setState(item => ({ ...item, offers: [] }));

      }
    })
  }


  handleBankChange(e) {
    console.log('---handleBankChange')
    if (e.id != '' && e.id > 0) {
      this.setState({ selectedBank: e.id })
    }
    else {
      this.setState({
        selectedBank: null
      })
    }
  }

  handleOfferChange(offer) {
    this.setState(item => ({ ...item, offer_id: offer.id }));
  }

  handleBrandChange(e) {
    const urlParams = new URLSearchParams(window.location.search);
    const idFromUrl = urlParams.get('id');
    const customerId = urlParams.get('customer');

    let selectedBrand = null;
    if (customerId && Array.isArray(e)) {
      selectedBrand = e.length > 0 ? e[e.length - 1] : null;
    } else {
      selectedBrand = e === '' ? null : e;
    }

    this.setState({ selectedBrand: selectedBrand }, () => {
      if (this.state.selectedBrand?.id && idFromUrl) {
        this.handleGetOfferbyBrand(this.state.selectedBrand.id);
      }
    });

    if (typeof e === 'string' && e.trim() !== '') {
      this.handleBrandSearch(e);
    } else if (!Array.isArray(e) && typeof e === 'object' && e !== null && typeof (e.id) === 'undefined') {
      this.handleBrandSearch(e);
    }
  }

  handleBrandSearch = debounce((searchTerms) => {
    this.brandSearch(searchTerms)
  }, 500)

  brandSearch(searchTerms) {
    console.log('handleBrandSearch')
    let params = {}
    let search = {}
    search['search[name]'] = encodeURIComponent(searchTerms.trim())
    Object.assign(params, search);
    store.dispatch(getBrands(params)).then((result) => {
      let brandSearchResult = result.payload.items.map(brand => ({ id: brand.id, name: brand.name }));
      this.setState({ brandSearchResult: brandSearchResult });
    }).catch((error) => {
      //throw new SubmissionError({_error:  error });
      this.setState({
        error: error,
        modalOpen: true
      });
    });
  }

  // Save Transaction
  async submit(values) {
    const urlParams = new URLSearchParams(window.location.search);

    const customerId = urlParams.get('customer');

    let action

    if (this.state.brands != null) {
      values.brand_ids = values?.brands?.map(item => item.id)
    }
    else {
      values.brand_ids = [];
    }




    values.bank_id = this.state.selectedBank

    if (this.state.id) {
      values.brand_id = values.brand
    } else {
      if (customerId && Array.isArray(values.brand)) {
        values.brand_ids = values.brand.map(brand => brand.id);
        values.brand_id = values.brand.length > 0 ? values.brand[0].id : null;
      } else if (this.state.selectedBrand != null && values.brand) {
        values.brand_id = values.brand.id
      } else {
        values.brand_id = null;
      }
    }


    if (this.state.create) {
      console.log('addTransaction')
      console.log(values)
      values = {
        ...values,
        type: 'deposit',
        currency: this.currency.current.value,
        commission: this.commission.current.value,
        ...(customerId && {
          offer_id: this.state?.offer_id || '',
          reference: Math.floor(Math.random() * 10000),
          customer_id: customerId
        })

      }
      action = addTransaction(values);
    }
    else {
      action = updateTransaction({ id: values.id, status: values.status }, this.props.match.params.bank_id);
    }

    store.dispatch(action).then((result) => {
      if (typeof (result) != 'undefined') {
        if (this.state.create && result?.payload?.data) {
          console.log(values, 'status')
          const data = { ...result?.payload?.data, status: values.status }
          store.dispatch(updateTransaction({
            id: result?.payload?.data.id,
            status: values.status,
          }, values.bank_id)).then(() => {
            if (customerId) {
              window.history.back();
            } else {
              window.location.href = `/transactions/transactions?bank_id=${values.bank_id}`;
            }
          }).catch((error) => {
            alert(error.message || error);
          })
          this.setState({ open: true });


        }

        if (!this.state.create) {
          this.setState({ open: true });
          window.location.href = `/transactions/transactions?bank_id=${this.props.match.params.bank_id}`;
        }
      }
    }).catch((error) => {
      throw new SubmissionError({ _error: error })
    })
  }

  handleClose() {
    this.setState({ open: false });
  }

  handleStatusChange(e) {
    this.setState({ status: e == '' ? null : e });
  }





  render() {
    const session = this.props.session
    if (typeof (session.forceLogout) != "undefined" && session.forceLogout == 1) {
      this.setState({ session: null });
      window.location.href = "/login";
    }


    const urlParams = new URLSearchParams(window.location.search);
    const idFromUrl = urlParams.get('id');
    const customerId = urlParams.get('customer');

    const { error, handleSubmit, pristine, reset, submitting, message, brands, transaction, banks } = this.props

    let status = ''
    if (transaction != null && this.state.status == null) {
      status = transaction.status;
    } else {
      status = this.state.status;
    }

    let brandsArr = brands
      .map(brand => ({ id: brand.id, name: brand.name }))
    if (this.state.brandSearchResult != null) {
      brandsArr = this.state.brandSearchResult
    }
    brandsArr = brandsArr.concat({ id: 0, name: '...' })

    const banksArr = this.state.banks.map(bank => ({ id: bank.id, name: bank.name }));

    return (
      <div className="animated fadeIn mt-5">
        <form onSubmit={handleSubmit(this.submit)}>
          <Row>
            <Col xs="12" lg="12">
              <Card>
                <CardHeader><i className="fa fa-align-justify"></i> Transaction</CardHeader>

                <CardBody>
                  <Row className="form-sections">
                    {!this.state.id && <Col xs="12" lg="6">
                      <FormSection className="form-section">
                        <Card>
                          <CardBody>
                            <CardTitle className="d-inline">Transaction details</CardTitle>


                            {banksArr.length > 0 &&
                              <div className="mb-2 mr-2">
                                <label>Bank id <span className="text-danger">*</span></label>

                                <Combobox
                                  placeholder="Choose Bank"
                                  data={[].concat(banksArr)}
                                  valueField="id"
                                  textField="name"
                                  defaultValue={
                                    idFromUrl && banksArr.length > 0 ?
                                      {
                                        id: parseInt(idFromUrl),
                                      } :
                                      { id: this.state.selectedBank != null ? this.state.selectedBank : 0, name: (this.state.selectedBank != null && banksArr?.length > 0) ? banksArr?.find(b => b.id == this.state.selectedBank)?.name : '' }}
                                  type="select"
                                  filter={false}
                                  asterisk="*"
                                  className="mb-4"
                                  onChange={this.handleBankFilterChange}
                                />
                              </div>}


                            {/*<Field*/}
                            {/*  name="type"*/}
                            {/*  component={renderField}*/}
                            {/*  label="Type"*/}
                            {/*  className="form-control"*/}
                            {/*  asterisk="*"*/}
                            {/*/>*/}
                            {/*<br/>*/}

                            <Row>
                              <Col xs="6">
                                <Field
                                  name="amount"
                                  component={renderField}
                                  label="Amount"
                                  type={'text'}
                                  className="form-control"
                                  asterisk="*"
                                />
                              </Col>
                              <Col xs="6">

                                {/*<Field*/}
                                {/*  name="currency"*/}
                                {/*  type={'text'}*/}
                                {/*  asterisk="*"*/}
                                {/*  component={renderField}*/}
                                {/*  label="Currency"*/}
                                {/*  defaultValue={'currency'}*/}
                                {/*  className="form-control"*/}
                                {/*/>*/}

                                <div className="mb-2 mr-2">
                                  <label>Currency <span
                                    className="text-danger">*</span>
                                  </label>
                                  <div>
                                    <input name="currency" ref={this.currency} type="text" defaultValue={'EUR'} className="form-control" />
                                  </div>
                                </div>
                              </Col>
                            </Row>
                            <br />

                            <Field
                              name="brand"
                              type="select"
                              component={renderCombobox}
                              label="Brand - type to search Brand e.g. Adidas"
                              data={brandsArr}
                              defaultValue={customerId ? [] : this.state.selectedBrand}
                              valueField="id"
                              textField="name"
                              filter={true}
                              className="p-0 pr-2"
                              onChange={(event) => this.handleBrandChange(event)}
                              onSearch={(searchTerm) => this.handleBrandSearch(searchTerm)}
                              disabled={[{ id: 0, name: '...' }]}
                              asterisk="*"
                            />
                            <br />


                            {(this.state.offers?.length > 0 && customerId) ?
                              <>
                                <Field
                                  name="offer_id"
                                  type="select"
                                  component={renderCombobox}
                                  label="Offer - type to search Offer e.g. Adidas"
                                  data={this.state.offers || []}
                                  valueField="id"
                                  textField="title"
                                  filter={true}
                                  className="p-0 pr-2"
                                  onChange={(event) => this.handleOfferChange(event)}
                                  disabled={[{ id: 0, name: '...' }]}
                                  asterisk="*"
                                />
                                <br />
                              </> : null
                            }


                            <Field
                              name="booked_at"
                              type="date"
                              component={renderDateFieldGerman}
                              label="Booked at"
                              className="form-control"
                              asterisk="*"
                            />
                            <br />

                            <div className="mb-2 mr-2">
                              <label>Commission </label>
                              <div>
                                <input ref={this.commission} name="commission" type="text" className="form-control" min="-999999.99"
                                  max="999999.99" step="0.01" defaultValue={'0.00'} />
                              </div>
                            </div>
                            <br />

                            <Field
                              name="net_amount"
                              type="text"
                              component={renderField}
                              label="Net amount"
                              className="form-control"
                              asterisk="*"
                            />
                            <br />

                            <div className={`${customerId ? 'position-absolute invisible' : ''}`}>
                              <Field
                                name="customer_id"
                                type="text"
                                component={renderField}
                                label="Customer id"
                                className={`form-control`}
                                asterisk="*"
                              />
                              <br />
                            </div>


                            <div className={`${customerId ? 'position-absolute invisible' : ''}`}>

                              <Field
                                name="offer_id"
                                type="text"
                                component={renderField}
                                label="Offer id"

                                className="form-control"
                                asterisk="*"
                              />
                              <br />


                              <Field
                                name="reference"
                                component={renderField}
                                label="Reference"
                                className="form-control"
                                asterisk="*"
                              />
                              <br />

                            </div>


                            {customerId && <>
                              <Field
                                name="payment_id"
                                type="text"
                                component={renderField}
                                label="Payment id"
                                className="form-control"
                              />
                              <br />
                            </>}



                            <Field
                              name="notes"
                              type="text"
                              component={renderSelectField}
                              options={[{ value: 'nachbuchung', text: 'Nachbuchung' }, { value: 'kulanz', text: 'Kulanz' }]}
                              label="Notes"
                              className="form-control"
                            />

                            <Field
                              name="online"
                              type="checkbox"
                              component={renderCheckbox}
                              label="Online"
                              className="form-control"
                            />

                          </CardBody>
                        </Card>
                      </FormSection>
                    </Col>}


                    <Col xs="12" lg="6">
                      <FormSection className="form-section">
                        <Card>
                          <CardBody>
                            <CardTitle className="d-inline">Transaction status</CardTitle>
                            <Field name="status" className="mt-3" component={renderRadioGroup} defaultValue={status} onChange={this.handleStatusChange}>
                              {
                                !this.props.match.params.id && <FormControlLabel value="pending" control={<Radio color="primary" />} label="Pending" />
                              }
                              <FormControlLabel value="confirmed" control={<Radio color="primary" />} label="Confirmed" />
                              {
                                !customerId && <FormControlLabel value="declined" control={<Radio color="primary" />} label="Declined" />

                              }
                            </Field>
                          </CardBody>
                        </Card>
                      </FormSection>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs="12">
                      {!!error && <div className="form-error mt-3">{error && <strong>{error}</strong>}</div>}
                      <button type="submit" className="btn btn-primary mt-5"
                        disabled={(!this.state.selectedBank && !this.state.id) || pristine || submitting}>
                        Submit</button>
                    </Col>
                  </Row>
                </CardBody>


              </Card>
            </Col>
          </Row>
        </form>
        <Snackbar open={this.state.open} autoHideDuration={2000} message="Saved" onClose={() => this.setState({ open: false })}
          action={
            <React.Fragment>
              <a className="text-white cursor-pointer mr-2" aria-label="close" onClick={this.handleClose}><i className="cil-x"></i></a>
            </React.Fragment>
          }
        />
      </div >
    )
  }
}

TransactionForm.propTypes = {
  pristine: PropTypes.bool,
  message: PropTypes.string,
  submitting: PropTypes.bool,
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  transaction: PropTypes.object,
  brands: PropTypes.array,
  session: PropTypes.any
};

function mapStateToProps(state) {
  console.log('STATE');
  console.log(state);
  return {
    //formData: state.transactions,
    initialValues: typeof (state.transactionForm) !== 'undefined' ? state.transactionForm.transaction : null,
    transaction: typeof (state.transactionForm) !== 'undefined' ? state.transactionForm.transaction : null,
    brands: (typeof (state.brands) !== 'undefined' && typeof (state.brands.result) !== 'undefined') ? state.brands.result.items : [],
    banks: (typeof (state.banks) !== 'undefined' && typeof (state.banks.result) !== 'undefined') ? state.banks.result.items : [],
    session: state.session
  }
};

const mapDispatchToProps = dispatch => bindActionCreators({ getTransaction, addTransaction, updateTransaction, resetTransaction, getBrands, getBanks, checkAuth }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({
  form: 'transactionForm', // a unique identifier for this form,
  enableReinitialize: true,
  validate
})(TransactionForm))